import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { getPurchaseAttributionBundle } from "@/lib/lastTouchAttribution";

export const useCreditPackPurchase = () => {
  const { toast } = useToast();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (packId: string) => {
      const attribution = getPurchaseAttributionBundle();
      const { data, error } = await supabase.functions.invoke(
        'create-credit-pack-checkout',
        {
          body: { packId, ...attribution },
        }
      );

      if (error) throw error;
      if (!data?.clientSecret) throw new Error('No checkout client secret returned');

      return data.clientSecret;
    },
    onSuccess: (clientSecret: string) => {
      const params = new URLSearchParams({
        clientSecret,
        returnTo: "/profile",
      });
      navigate(`/checkout?${params.toString()}`);
    },
    onError: (error: Error) => {
      console.error('Credit pack purchase error:', error);
      toast({
        title: "Purchase Failed",
        description: error.message || "Unable to start checkout. Please try again.",
        variant: "destructive",
      });
    },
  });
};
